import { personAbonnementerForm } from "../../../../../config/form/person/mereOmPerson/personAbonnementerFormConfig";
import { defaultPersonAbonnementerColumns } from "../../../../../config/person";
import { getHeaderActiveColumns, TD } from "../../../../../util/table";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import ButtonDownload from "../../../../ButtonDownload";
import ActiveIcon from "../../../../icons/ActiveIcon";
import TableBasic, { TableRow } from "../../../../Table/TableBasic";
import IngenRegistreringer from "../IngenRegistreringer";
import { PersonDto } from "../../../../../interfaces/schema";
import { SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";
import { periodeIsActive } from "../../../../../util/date";
import { orderBy } from "../../../../../util/orderBy";

export default function Abonnementer({
  invalidateData,
  person,
}: {
  person: PersonDto;
  invalidateData: InvalidateDataFunction<any>;
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const canWrite = hasPermission(user, "BasisWrite");
  const { personAbonnement } = person;
  const [activeColumns, setActiveColumns] = useActiveColumns(
    "person-personabonnementer-active-columns",
    defaultPersonAbonnementerColumns,
  );
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "personAbonnementerSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );

  if (!personAbonnement?.length) {
    return (
      <IngenRegistreringer
        editConfig={
          canWrite ? personAbonnementerForm(person.id, undefined) : undefined
        }
        invalidateData={invalidateData}
      />
    );
  }

  // event handlers
  function downloadHandler() {
    tableToXLSX(activeColumns, personAbonnement ?? [], {
      fileName: `abonnementer-for-${person.kundeNr}`,
      additionalData: {
        kundenr: person.kundeNr,
      },
    });
  }

  return (
    <>
      <ButtonDownload onClick={downloadHandler} />
      <TableBasic
        editConfig={
          canWrite ? personAbonnementerForm(person.id, undefined) : undefined
        }
        invalidateData={invalidateData}
        defaultColumns={defaultPersonAbonnementerColumns}
        columns={activeColumns}
        setActiveColumns={setActiveColumns}
        headerRow={
          <>
            <th className="indicator"></th>
            {getHeaderActiveColumns(activeColumns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
          </>
        }
      >
        {orderBy(
          personAbonnement,
          sortBy.map((ds) => ds.field),
          sortBy.map((ds) => ds.direction),
        ).map((abon) => {
          return (
            <TableRow
              key={abon.id}
              editConfig={
                canWrite
                  ? personAbonnementerForm(person.id, abon.id)
                  : undefined
              }
              invalidateData={invalidateData}
            >
              <td
                className={`indicator${
                  periodeIsActive(
                    new Date(abon.periode.fraDato),
                    new Date(abon.periode.tilDatoInklusiv),
                  )
                    ? " has-effect"
                    : ""
                }`}
              >
                <ActiveIcon />
              </td>
              <>
                {activeColumns
                  .filter((col) => col.active)
                  .map((col) => {
                    return <TD key={col.field} col={col} rowData={abon} />;
                  })}
              </>
            </TableRow>
          );
        })}
      </TableBasic>
    </>
  );
}
const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "periode.fraDato",
  },
];
